module.exports = __webpack_public_path__ + "static/img/twin-city-2.399e5468.png";